import React,
{
  useState,
  useEffect,
  useMemo
} from "react";
import LinkWrapper from "../../LinkWrapper";
import OtherPlatforms from "../../OtherPlatforms";
import ReleaseNotes from "../../ReleaseNotes";
import DownloadButton from "../../UI/DownloadButton";
import VersionModal from "../../VersionModal";
import { getDownloadPageUrl } from "../../../routes/clientUrls";
import { IVersion } from "../../../utils/fetchers/types";
import {
  addPageScroll,
  compareVersions,
  downloadButtonText,
  removePageScroll
} from "../../../utils/helpers";

import styles from './Item.module.css'

type TItem = {
  client: string,
  version: IVersion;
  currentVersion: string,
}

const Item: React.FC<TItem> = ({ client, version, currentVersion }) => {
  const { releaseNotes, platforms } = version;
  const { platform, fileName } = platforms[0];

  const [currentFileName, setCurrentFileName] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModal = () => {
    setIsModalOpen(true);
    addPageScroll();
  }
  const closeModal = () => {
    setIsModalOpen(false);
    removePageScroll();
  }

  const [isModalNeed, setIsModalNeed] = useState(false);

  const releaseNotesMemo = useMemo(() => <ReleaseNotes releaseNotes={releaseNotes} />, [releaseNotes])

  useEffect(() => {
    if (currentVersion) {
      setIsModalNeed(compareVersions(currentVersion, version.version));
    }
  }, [currentVersion, version.version]);

  return (
    <div id={version.version} className={styles.wrapper}>
      <div className={styles.topWrapper}>
        <div
          className={styles.title}>
          Release {version.version}
        </div>
        <div
          className={styles.date}>
          Release Date: {version.releaseDate}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.contentLeft}>
          <LinkWrapper
            href={getDownloadPageUrl(fileName)}
            condition={!isModalNeed}>
            <DownloadButton
              variant="primary"
              size='sm'
              platform={platform}
              fileName={fileName}
              text={downloadButtonText(client, platform)}
              onClick={isModalNeed ? handleModal : undefined}
              setCurrentFileName={setCurrentFileName}
            />
          </LinkWrapper>
          <div className={styles.marginTop}>
            <OtherPlatforms
              setCurrentFileName={setCurrentFileName}
              version={version.version}
              client={client}
              needModal={isModalNeed}
              onClick={handleModal}
              size="sm"
              platforms={platforms.slice(1)} />
          </div>
        </div>
        <div className={styles.contentRight}>
          {releaseNotesMemo}
        </div>
      </div>
      {
        isModalNeed &&
        <VersionModal
          fileName={currentFileName}
          onClick={closeModal}
          currentVersion={currentVersion}
          version={version.version}
          isOpen={isModalOpen}
        />
      }
    </div>
  );
};

export default Item;